module.exports = __webpack_public_path__ + "static/media/254-nato.a7c336a6.svg";